import { DEFAULT_LOCALE, type SupportedLocale, toSupportedLocale } from "@offstreetparking/domain/i18n";
import { appConfig } from "../app.config";

// Freshdesk's portal language codes, which differ from ours: Latin American Spanish is `es-LA`
// (Freshdesk's `es-419` is an internal test locale that 404s) and there is no Canadian French.
// The primary language takes no prefix, and a language that is not enabled in the Freshdesk admin
// redirects to the primary-language page with the query string intact.
const FRESHDESK_PORTAL_LANGUAGE: Record<SupportedLocale, string | null> = {
	en: null,
	fr: "fr",
	es: "es-LA",
};

export type SupportUrlParams = {
	locale: string;
	locationId?: string | null;
	eventId?: string | null;
	ticketForm?: string;
	parkerId?: number | null;
};

export const buildSupportUrl = ({ locale, locationId, eventId, ticketForm, parkerId }: SupportUrlParams) => {
	const portalLanguage = FRESHDESK_PORTAL_LANGUAGE[toSupportedLocale(locale) ?? DEFAULT_LOCALE];
	const url = new URL(
		`${appConfig.HELP_CENTER_URL}${portalLanguage ? `/${portalLanguage}` : ""}/support/tickets/new`,
	);
	url.searchParams.set("support_type", "parker");
	if (ticketForm) {
		url.searchParams.set("ticket_form", ticketForm);
	}
	if (locationId) {
		url.searchParams.set("location", locationId);
	} else if (eventId) {
		url.searchParams.set("event", eventId);
	}
	if (parkerId) {
		url.searchParams.set("parker", String(parkerId));
	}
	return url.toString();
};
